import type { LoyaltyPurchasePoints } from '@libs/common-node';
import { AUTH_HEADERS, type Nullable } from '@libs/core';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';

// TODO: can be deleted once removed from userSessionWrapper
export async function getLoyaltyPoints(token: string | undefined): Promise<Nullable<LoyaltyPurchasePoints>> {
    if (!token) {
        return null;
    }

    const url = CWEA_ENDPOINTS.loyalty.getLoyaltyPoints;
    const response = await client.cwea<LoyaltyPurchasePoints[]>(url, {
        headers: {
            [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
        },
    });

    if (!Array.isArray(response)) {
        return null;
    }

    return response.find(points => points.type === 'Purchase_Points');
}
